import { defineStore } from "pinia";

export const useTagStore = defineStore("tagStore", {
  state: () => ({
    searchTags: [],
    tags: [],
    tagsMode: "all", // all | any
  }),
  actions: {
    setValue(keyValue) {
      if (keyValue?.key in this) {
        this[keyValue.key] = keyValue.value;
      }
    },
    addSearchTag(tagToAdd) {
      const normalizedTag = {
        ...tagToAdd,
        __type: tagToAdd?.__type || "include",
      };
      const indexDelete = this.searchTags.findIndex((tag) => {
        return tag.id === normalizedTag.id;
      });
      if (indexDelete === -1) {
        this.searchTags.push(normalizedTag);
      } else {
        this.searchTags[indexDelete].__type = normalizedTag.__type;
      }
    },
    removeSearchTag(tagToDelete) {
      const indexDelete = this.searchTags.findIndex((tag) => {
        return tag.id === tagToDelete.id;
      });
      if (indexDelete !== -1) {
        this.searchTags.splice(indexDelete, 1);
      }
    },
    renameSearchTag(tagWithNewName) {
      const oldTagIndex = this.searchTags.findIndex((tag) => {
        return tag.id === tagWithNewName.id;
      });

      if (oldTagIndex !== -1) {
        this.searchTags[oldTagIndex].text = tagWithNewName.text;
      }
    },
    addTag(tagToAdd) {
      const exists = this.tags.some((tag) => tag.id === tagToAdd.id);
      if (!exists) {
        const tagWithCount = {
          ...tagToAdd,
          count: 0,
        };

        this.tags.push(tagWithCount);
      }
    },
    removeTag(tagToRemove) {
      const index = this.tags.findIndex((tag) => tag.id === tagToRemove.id);
      if (index !== -1) {
        this.tags.splice(index, 1);
      }
    },
    updateTag(updatedTag) {
      const index = this.tags.findIndex((tag) => tag.id === updatedTag.id);
      if (index !== -1) {
        this.tags.splice(index, 1, {
          ...this.tags[index],
          ...updatedTag,
        });
      }
    },
    incrementTagCount(tagId) {
      const tag = this.tags.find((t) => t.id === tagId);
      if (tag) {
        if (!tag.count) tag.count = 0;
        tag.count++;
      }

      const searchTag = this.searchTags.find((t) => t.id === tagId);
      if (searchTag) {
        if (!searchTag.count) searchTag.count = 0;
        searchTag.count++;
      }
    },
    decrementTagCount(tagId) {
      const tag = this.tags.find((t) => t.id === tagId);
      if (tag && tag.count && tag.count > 0) {
        tag.count--;
      }

      const searchTag = this.searchTags.find((t) => t.id === tagId);
      if (searchTag && searchTag.count && searchTag.count > 0) {
        searchTag.count--;
      }
    },
    setTagsMode(mode) {
      if (mode === "all" || mode === "any") {
        this.tagsMode = mode;
      }
    },
    SET_VALUE(keyValue) {
      this.setValue(keyValue);
    },
    ADD_SEARCH_TAG(tag) {
      this.addSearchTag(tag);
    },
    REMOVE_SEARCH_TAG(tag) {
      this.removeSearchTag(tag);
    },
    RENAME_SEARCH_TAG(newTag) {
      this.renameSearchTag(newTag);
    },
    ADD_TAG(tag) {
      this.addTag(tag);
    },
    REMOVE_TAG(tag) {
      this.removeTag(tag);
    },
    UPDATE_TAG_SYNC(updatedTag) {
      this.updateTag(updatedTag);
    },
    INCREMENT_TAG_COUNT(tagId) {
      this.incrementTagCount(tagId);
    },
    DECREMENT_TAG_COUNT(tagId) {
      this.decrementTagCount(tagId);
    },
    SET_TAGS_MODE(mode) {
      this.setTagsMode(mode);
    },
  },
});

export default useTagStore;
